<template>
    <div>
        <BoxPaciente
            ref="BoxPaciente"
            :data="data"
        />

        <rkm-row            
            class="mt-2 mb-2"
        >
            <rkm-col>
                <template>
                    <rkm-button
                        color="info"
                        class="mb-2"
                        @click="imprimirHistorico()"
                        :disabled="!data.model.agendamentos || data.model.agendamentos.length === 0"
                    >
                        Imprimir histórico
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <rkm-table     
            :fields="fields.tables.excluidos"
            :items="data.model.agendamentosExcluidos"
            ref="Table"
            hide-filters
        >
            <template #cell(exames)="data">
                <span v-for="(exame, index) in data.item.exames" :key="index">
                    {{ exame.nomeExame }}<span v-if="index < data.item.exames.length - 1">, </span>
                </span>
            </template>            
        </rkm-table>    
    </div>
</template>

<script>

// Components.
import BoxPaciente from '@/components/exame-imagem/agendamento/paciente/Index'

// Filters.
import formats from '@/filters/formats'

// Vuex.
import { mapActions } from 'vuex'

//Enums
import status from '@/enums/exame-imagem/fechamento/status'

// Mixins.
import { repository, error, object, data, stringCase, printExameImagem } from '@/mixins'

export default {
    components:{ BoxPaciente },
    computed:{
        fields() {

            return {
                tables: {
                    excluidos: [
                        { key: 'agendamentoNumero', label: 'Agendamento', class: 'col-min'},
                        { key: 'dataHoraCriacao', label: 'Data/Hora criado', class: 'col-min'},
                        { key: 'usuarioAgendador', label: 'Agendado por', class: 'col-max'},
                        { key: 'exames', label: 'Exames excluídos', class: 'col-max'}, 
                        { key: 'usuarioExclusao', label: 'Excluído por', class: 'col-max'},
                        { key: 'dataHoraExclusao', label: 'Data/Hora exclusão', class: 'col-min'},
                    ]
                }
            }
        },
    },
    created() {

        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamento'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
        }
    },
    data:() => ({
        exames:[],
        agendamento: {
            data: null,
            grupoExameId: null,
            grupoExameNome: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            agendamentoId: '',
            unidadeId: null,
            unidadeNome: '',
            unidadeDisabled: false,
            usuarioId: '',
            urgente: false,
            periodo: {
                start: null,
                end: null,
            },
            prestadorId: null,
            prestadorNome: '',
            medicoNome: '',
            medicoId: null,
        },
        isReadOnly: false,
        enums: {
            status
        },
    }),
    filters: {
        ...formats,
    },
    methods: {
    ...mapActions(['setLoading', 'unsetLoading']),
    imprimirHistorico(){

        this.setLoading()

        this.repositories.impressao.historicoExame(this.data.form.paciente.id)
            .then(response => {

                const content = new Blob([response.data], {type: response.headers['content-type']})
                const url = URL.createObjectURL(content)
                const link = document.createElement('a')

                link.href = url
                link.target = '_blank'
                link.click()
                link.remove()
            })
            .finally(() => this.unsetLoading())
    },
    },
    mixins: [ repository, error, object, data, stringCase, printExameImagem ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>

<style scoped>
p {
    margin: 0px;
}
.col-svg {
    text-align: center !important;
}
.icon {
    width: auto !important;
    height: 96px !important;
    color: #007bff !important;
}
.warning {
    color: var(--warning);
}
.primary {
    color: var(--primary);
}
.colorButton {
    color: #fff;
}
</style>